export class Supplier {
    supplierId: number;
    address: string;
    name: string;
    mobile: string;
    pinCode: string;
    city: string;
    supplierOf: string;
    email: string;
    createdDate: Date;
    totalItems?: number;
    supplierEncryptId?: string;
    domain?: string;
    link: string;
    bankName: string;
    ifscCode: string;
    accountNumber: string;
    accountHolderName: string;
    emails: Array<any>;
    supplierIds: string;
    isLoading: boolean;
    userId?: number;
    dueDays?: number;
    contactPersonName: string;
    drugLicense: string;
    gstNo: string;
    pan: string;
    deliverDays?: number;

}